(function () {
    "use strict";

// class TextInputController extends Components.InputBaseController {

// @ngInject
function EmailInputControllerCtor(
        $scope, $element, $attrs, $compile, $translate, _, $window) {

    this.constructor.$super.call(this, $scope, $element, $attrs, $compile, $translate, _, $window);

    this.__objectType = 'PhoneInputController';
    this.isRequired = false;
    this.validationError = '';
    this._ = _;
    this.$translate = $translate;
}

var EmailInputController = Class(Components.InputBaseController, {
    constructor: EmailInputControllerCtor,

    // $onInit() {
    $onInit: function $onInit() {
        // super.$onInit();
        // super.validate();
        this.constructor.$superp.$onInit.call(this);
        this.textInputVariant = 'email';
        this.cssClass['form-element--phone'] = true;

        // Confusing, but this is used to set the initial value of the
        // ng-form HTML element and then after initialization
        // "formName" represents that DOM element.
        //this.formName = `${this.name}Form`;
        this.formName = this.name + 'Form';
    },

    // onChange() {
    onChange: function onChange() {
        // super.onChange();
        // super.validate();
        this.constructor.$superp.onChange.call(this);
        this.constructor.$superp.validate.call(this);
    },

    onBlur: function onBlur() {
        // super.onChange();
        // super.validate();
        this.constructor.$superp.onBlur.call(this);
        this.validate();
    },

    // shouldShowError() {
    shouldShowError: function() {
        return (this.validationError !== ''
            && (this.formName[this.name].$dirty
                || this.formName.$$parentForm.$submitted)
        );
    },

    // validate() {
    validate: function() {
        var baseValidation = this.constructor.$superp.validate.call(this);
        if (!baseValidation) {
            return false;
        }

        // Loose US and intl phone number validation
        // make sure it consists of numbers, spaces, dashes, periods, or paranthesis
        var isEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(this.value);
        if (!isEmail) {
            this.validationError = this.$translate.instant('ERRORS._INVALID_EMAIL_ADDRESS_');
            return false;
        }

        this.validationError = '';
        return true;
    },

});

Components.EmailInput = {
    templateUrl: 'angular/app/modules/common/ui_components/form/text_input.html',
    controller: EmailInputController,

    // Requiring ngModel is a hack that allows us access to the
    // ng form API ($dirty, $valid, $isSubmitted, etc), while still preserving
    // the essence of a unidirectional data flow (e.g. Container -> form -> inputs)
    require: {
        model: 'ngModel'
    },

    bindings: {
        flavor: '@',
        label: '@',
        maximumLength: '@',
        minimumLength: '@',
        name: '@',
        caption: '@',
        tabIndex: '@',
    }
};

}());